<template>
  <div>
    <div v-if="!loading">
      <CompanyJobsList
        v-on:backToJobs="({view: 'viewAllJobs', name: 'all'})"
        v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
        v-on:jobDetail="toJobDetail"
        v-on:editJob="toJobEdit"
        :jobCreatorId="jobCreatorId"
        :companyJobsList="bodyList"
        v-bind:isBusinessJobListPage="isBusinessJobListPage"
      />
    </div>

    <!-- Loader Component Here -->
    <div v-if="loading">
      <Loader />
    </div>

  </div>
</template>

<script>
import CompanyJobsList from '../../components/JobsList/CompanyJobsList.vue';
import Loader from '../../components/body/Loader.vue';

export default {
  name: 'BusinessJobsList',
  props: ['jobCreatorId'],
  components: {CompanyJobsList, Loader},
  data() {
    return {
      loading: true,
      bodyList: [],
      allJobs: null,
      isBusinessJobListPage: true
    };
  },
  async mounted() {
    await this.getPosts();
  },
  methods: {
    toJobDetail(id) {
      this.$emit('jobDetail', id);
    },
    toJobEdit(id) {
      this.$emit('editJob', id);
    },
    getPosts() {
      this.$store
      .dispatch('getMyPosts')
      .then((res) => {
        if(res.response){
          this.bodyList = [];
          this.allJobs = [];
          let body = {};
          let results = this.$store.state.myPosts;

          // count application status on each company's jobs
          results.forEach(job => {
            // Build bodylist of each job
            let inReviewCount = 0;
            let scheduledForInterviewCount = 0;
            let shortlistedCount = 0;
            let declinedCount = 0;
            let hiredCount = 0;

            job.applications.forEach(application => {
              switch(application.status) {
                case 'in-review':
                  inReviewCount = inReviewCount + 1;
                  break;
                case 'scheduled-for-interview':
                  scheduledForInterviewCount = scheduledForInterviewCount + 1;
                  break;
                case 'declined':
                  declinedCount = declinedCount + 1;
                  break;
                case 'shortlisted':
                  shortlistedCount = shortlistedCount + 1;
                  break;
                case 'hired':
                  hiredCount = hiredCount + 1;
                  break;
                default:
                  null;
                  break;
              }
            });

            body = {
              // email: job.companyContactEmail? job.companyContactEmail: '—',
              // contactPerson: job.companyContactPerson? job.companyContactPerson: '—',
              // phone: job.companyContactNumber? job.companyContactNumber: '—',
              // jobID: job.id,
              // date: job.jobDeadline !== ''
              //   ? new Date(job.jobDeadline).toDateString()
              //   : '',
              inReviewCount: inReviewCount? inReviewCount: '0',
              scheduledForInterviewCount: scheduledForInterviewCount? scheduledForInterviewCount : '0',
              declinedCount: declinedCount? declinedCount: '0',
              shortlistedCount: shortlistedCount? shortlistedCount: '0',
              hiredCount: hiredCount? hiredCount: '0',
              applications: job.applications,
              id: job.id,
              creator: job.creator,
              title: job.title,
              category: job.category,
              city: job.city,
              state: job.state,
              createdAt: job.createdAt,
              jobDeadline: job.jobDeadline,
              status: job.status,
              // companyName: !job.companyName || job.companyName === ''
              //   ? `${this.getUserDetails.firstName} ${this.getUserDetails.lastName}`
              //   : job.companyName,
              companyName:
              job.companyName ? job.companyName
              : `${this.getUserDetails.companyName}` ? `${this.getUserDetails.companyName}`
              : `${this.getUserDetails.firstName} ${this.getUserDetails.lastName}`,
            };

            if(!job.jobDeadline || new Date(job.jobDeadline) > Date.now()) {
              body['status'] = 'Active';
            } else if(new Date(job.jobDeadline) <= Date.now()) {
              body['status'] = 'Expired';
            }

            // Add application status count to each job on company object
            this.allJobs.push(body);

          });

          this.bodyList = this.allJobs.reverse();
          this.loading = false;

        } else {
          this.loading = false;
          this.bodyList = [];
        }
      })
      .catch((err) => {
        this.loading = false;
        this.$toastr.error(
          err.error.error ? err.error.error
          :err.error ? err.error.errorMessage
          :err.error,
          'Error'
        );
      });
    },
  },
  computed: {
    getUserDetails () {
      return this.$store.state.userData;
    }
  }
};
</script>
